import request from '@/util/request';
import qs from 'qs';

// 获取系统字典
export const getDict = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

// 获取业务字典
export const getBizDict = (params, options) =>
  request.get('/api/blade-system/dict-biz/dictionary', Object.assign({}, options, { params }));

// 获取项目列表
export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取仪表树
export const getMeterTree = (params, options) =>
  request.get('/api/shunt/meter/tree', Object.assign({}, options, { params }));

// 分页
export const getPageList = (params, options) =>
  request.get('/api/shunt/meter/page', Object.assign({}, options, { params }));

// 详情
export const getDetail = (params, options) =>
  request.get('/api/shunt/meter/detail', Object.assign({}, options, { params }));

// 新增
export const add = (params, options) =>
  request.post('/api/shunt/meter/save', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const update = (params, options) =>
  request.post('/api/shunt/meter/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const remove = (params, options) =>
  request.post('/api/shunt/meter/remove', qs.stringify(params), options);
